import { Layout } from '@eneco/flows/components';
import { createFlowProvider } from '@eneco/flows/utils';

import { routes, actions, initialContext } from './HeatPumpLeadFlow.config';
import { HeatPumpLeadFlowContext } from './types/context';

const { Provider, Navigation, Router } = createFlowProvider<HeatPumpLeadFlowContext>({
  routes,
  actions,
  initialContext,
});

const Flow = () => {
  return (
    <Provider>
      <Layout>
        <Layout.Header>
          <Navigation componentName="HeatPumpLeadFlowNavigation" />
        </Layout.Header>

        <Router />
      </Layout>
    </Provider>
  );
};

export default Flow;
